import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import Input from 'components/Input';
import CheckBox from 'components/CheckBox';

import DaysFilter from 'features/reports/view/desktop/DaysFilter';
import { statuses } from 'features/bonusProgram/data';

import './GiftRequestsFilter.scss';

const b = block('gift-requests-filter-desktop');

const GiftRequestsFilter = ({ model }) => {
  const { values, handlers } = model;
  const locale = useSelector(state => state.locale.locale);

  const checkboxes = statuses.map(item => (
    <label className={b('checkbox-wrapper')} key={item.key}>
      <div className={b('checkbox')}>
        <CheckBox
          checked={values.state.statuses.includes(item.value)}
          onChange={() => handlers.handleStatusChange(item.value)}
        />
      </div>
      <div className={b('checkbox-title')}>{locale[item.renderElement]}</div>
    </label>
  ));

  return (
    <form className={b()} onSubmit={handlers.handleFormSubmit}>
      <div className={b('header')}>
        {locale.filter}
      </div>
      <div className={b('top')}>
        <DaysFilter
          activeDay={values.state.activeDay}
          setActiveDay={handlers.handleDayChange}
        />

        <div className={b('or')}>{locale.or}</div>

        <div className={b('item')}>
          <div className={b('item-label')}>{locale.dateFrom}</div>
          <div className={b('item-field')}>
            <InputDate selected={values.state.beginDate} onChange={handlers.handleBeginDateChange} />
          </div>
        </div>

        <div className={b('item')}>
          <div className={b('item-label')}>{locale.dateUntil}</div>
          <div className={b('item-field')}>
            <InputDate selected={values.state.endDate} onChange={handlers.handleEndDateChange} />
          </div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('item')}>
          <div className={b('item-label')}>{locale.username}</div>
          <div className={b('item-field')}>
            <Input
              value={values.state.username}
              callBack={e => handlers.handleUsernameChange(e.currentTarget.value)}
              placeholder={locale.username}
              name="username"
            />
          </div>
        </div>

        <div className={b('checkbox-list')}>
          {checkboxes}
        </div>

        <div className={b('button')}>
          <Button type="submit" text={locale.acceptFilter} />
        </div>
      </div>
    </form>
  );
};

export default GiftRequestsFilter;
